export type CSVField = { id: number; isRequired: boolean; name: string };
export type CSVSelectOption = { isRequired: boolean; label: string; value: number };
export const ignoreField: CSVField = { id: 0, isRequired: false, name: 'Ignore' };
export const PACKAGE_DIMENSION_FIELD_IDS = [26, 27, 28] as const;

export const fields: CSVField[] = [
  ignoreField,
  { id: 1, isRequired: true, name: 'City *' },
  { id: 2, isRequired: true, name: 'Country *' },
  { id: 4, isRequired: true, name: 'Recipient Name *' },
  { id: 5, isRequired: true, name: 'Street Line 1 *' },
  { id: 6, isRequired: true, name: 'Zip/Postal Code *' },
  { id: 3, isRequired: false, name: 'Email' },
  { id: 7, isRequired: false, name: 'Company' },
  { id: 8, isRequired: false, name: 'Phone' },
  { id: 9, isRequired: false, name: 'State/Province' },
  { id: 10, isRequired: false, name: 'Street Line 2' },
  { id: 11, isRequired: false, name: 'Street Number' },
  { id: 12, isRequired: false, name: 'Order Date' },
  { id: 13, isRequired: false, name: 'Order Number' },
  { id: 14, isRequired: false, name: 'Order Amount' },
  { id: 15, isRequired: false, name: 'Order Currency' },
  { id: 16, isRequired: false, name: 'Order Weight' },
  { id: 17, isRequired: false, name: 'Order Weight Unit' },
  { id: 18, isRequired: false, name: 'Item Title' },
  { id: 19, isRequired: false, name: 'Quantity' },
  { id: 20, isRequired: false, name: 'SKU' },
  { id: 21, isRequired: false, name: 'Item Price' },
  { id: 22, isRequired: false, name: 'Item Currency' },
  { id: 23, isRequired: false, name: 'Item Weight' },
  { id: 24, isRequired: false, name: 'Item Weight Unit' },
  { id: 25, isRequired: false, name: 'Item Country of Origin' },
  { id: 26, isRequired: false, name: 'Package Width' },
  { id: 27, isRequired: false, name: 'Package Height' },
  { id: 28, isRequired: false, name: 'Package Length' },
  { id: 29, isRequired: false, name: 'Package Dimension Unit' },
];

export const fieldToSelectOption = (field: CSVField): CSVSelectOption => ({
  isRequired: field.isRequired,
  label: field.name,
  value: field.id,
});
